import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./motion";

const BG =
  "https://images.unsplash.com/photo-1714974528232-f62051870736?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxpbnRlbnNlJTIwYnVzaW5lc3MlMjBjb252ZXJzYXRpb24lMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3ODQwODU2Nzh8MA&ixlib=rb-4.1.0&q=85";

export const TheRule = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative overflow-hidden bg-ink py-24 md:py-36" data-testid="the-rule-section">
      <motion.div style={{ y }} className="absolute inset-0 -z-0 scale-110" aria-hidden>
        <img src={BG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ink/85" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-ink/70" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="mb-8 font-mono text-xs font-bold uppercase tracking-[0.22em] text-cyan" data-testid="the-rule-eyebrow">
            The only rule
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <blockquote className="max-w-4xl border-l-8 border-acid pl-6 md:pl-10" data-testid="the-rule-quote">
            <p className="font-display text-3xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
              Your next question has to come from their last answer. If it does not, you were not
              listening. <span className="text-acid">You were waiting.</span>
            </p>
          </blockquote>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 grid max-w-3xl grid-cols-1 gap-6 text-lg leading-relaxed text-white/85">
            <p>
              This is the one skill in the entire process. The moment you think you know where the
              conversation is going, your brain starts loading the next question before they finish
              answering.
            </p>
            <p className="text-white/70">
              A preloaded sequence may sound polished, but it stops being a conversation. Their answer
              should decide what you ask next.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-10 max-w-2xl border-2 border-acid p-6 md:p-8">
            <p className="mb-2 font-mono text-xs font-bold uppercase tracking-[0.18em] text-acid">Use this</p>
            <p className="text-lg font-semibold leading-relaxed text-white md:text-xl">
              Pause. Repeat one phrase they said. Ask about that.
            </p>
            <p className="mt-3 text-base leading-relaxed text-white/70">
              You do not need the perfect next question. You need the question their answer earned.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
